module.exports = __webpack_public_path__ + "media/game-win-1.9e43755e.mp3";